import React, { FC } from 'react';

import {
  IcFillBackIcon,
  IcFillNextIcon,
  IcPauseIcon,
  IcPlayIcon,
  IcRepeatTrackIcon,
  IcRepeatIcon,
  IcShuffleIcon,
} from '@gem/icons';

import { FAB } from '../../../../FAB/FAB';
import { AudioPlayerOrder, AudioPlayerRepeat, IAudioPlayerConfig } from '../../AudioPlayer.types';
import { AudioPlayerSpeed } from '../AudioPlayerSpeed/AudioPlayerSpeed';
import { useAudioPlayerControlsPresenter } from './AudioPlayerControls.presenter';
import styles from './AudioPlayerControls.styles.m.css';

interface IAudioPlayerControlsProps {
  isPlaying: boolean;
  currentSpeed: number;
  config: IAudioPlayerConfig;
  isShowOrder: boolean;
  isShowRepeat: boolean;
  hasPrevious: boolean;
  hasNext: boolean;
  speedTooltipText?: string;
  onTogglePlay(): void;
  onPrevious(): void;
  onNext(): void;
  onChangeSpeed(speed: number): void;
  onConfigUpdate(config: Partial<IAudioPlayerConfig>): void;
}

// TODO: add translations
const ORDER_TITLE_MAP = {
  [AudioPlayerOrder.Direct]: 'In Order',
  [AudioPlayerOrder.Reverse]: 'Reverse',
  [AudioPlayerOrder.Shuffle]: 'Shuffle List',
};

// TODO: add translations
const REPEAT_TITLE_MAP = {
  [AudioPlayerRepeat.None]: 'No Repeat List',
  [AudioPlayerRepeat.List]: 'Repeat List',
  [AudioPlayerRepeat.Track]: 'Repeat Track',
};

export const AudioPlayerControls: FC<IAudioPlayerControlsProps> = ({
  isPlaying,
  config,
  currentSpeed,
  isShowOrder,
  isShowRepeat,
  hasPrevious,
  hasNext,
  speedTooltipText,
  onTogglePlay,
  onPrevious,
  onNext,
  onChangeSpeed,
  onConfigUpdate,
}) => {
  const { changeOrder, changeRepeat } = useAudioPlayerControlsPresenter({
    config,
    onConfigUpdate,
  });

  return (
    <div className={styles.container}>
      <div className={styles.actions}>
        <FAB
          Icon={IcFillBackIcon}
          size="0"
          iconSize="10"
          theme="3_1"
          isDisabled={!hasPrevious}
          onClick={onPrevious}
        />

        <FAB
          Icon={isPlaying ? IcPauseIcon : IcPlayIcon}
          size="0"
          iconSize="10"
          theme="3_1"
          onClick={onTogglePlay}
        />

        <FAB
          Icon={IcFillNextIcon}
          size="0"
          iconSize="10"
          theme="3_1"
          isDisabled={!hasNext}
          onClick={onNext}
        />
      </div>

      <div className={styles.actions}>
        {isShowOrder && (
          <FAB
            // TODO: add translations
            title={ORDER_TITLE_MAP[config.order]}
            Icon={IcShuffleIcon}
            size="0"
            iconSize="10"
            theme={config.order === AudioPlayerOrder.Direct ? '3_1' : '3_2'}
            onClick={changeOrder}
          />
        )}

        {isShowRepeat && (
          <FAB
            // TODO: add translations
            title={REPEAT_TITLE_MAP[config.repeat]}
            Icon={config.repeat === AudioPlayerRepeat.Track ? IcRepeatTrackIcon : IcRepeatIcon}
            size="0"
            iconSize="10"
            theme={config.repeat === AudioPlayerRepeat.None ? '3_1' : '3_2'}
            onClick={changeRepeat}
          />
        )}

        <AudioPlayerSpeed
          tooltipText={speedTooltipText}
          currentSpeed={currentSpeed}
          isDisabled={false}
          onChange={onChangeSpeed}
        />
      </div>
    </div>
  );
};
